import * as Yup from "yup";

export const passwordSchema = Yup.string()
.min(8, "Contraseña debe contener al menos 8 caracteres")
.matches(/\w/, "Contraseña debe contener al menos una letra")
.required("Contraseña es requerido");

export const doublePassSchema = Yup.string()
    .oneOf([Yup.ref('password')], 'Las contraseñas no coinciden')
    .required('Por favor vuelva a ingresar la contraseña');

export const roleSchema = Yup.number()
.required("Sistema es requerido");

export const newUserValidationSchema = Yup.object({
  nombre: Yup.string().required("Nombre es requerido"),
  email: Yup.string()
    .email("No es un e-mail válido")
    .required("Email es requerido"),
  password: passwordSchema,
  doublePassword: doublePassSchema,
  role: roleSchema
});

export const editUserValidationSchema = Yup.object({
    nombre: Yup.string().required("Nombre es requerido edit"),
    email: Yup.string()
        .email("No es un e-mail válido")
        .required("Email es requerido"),
    password: Yup.string().test({
        name: "editPassword",
        skipAbsent: true,
        test(value, ctx) {
            // como estamos editando validamos ok si es undefined
            if (!value) return true;
            try {
                passwordSchema.validateSync(value);
                return true;
            } catch (error) {
                return ctx.createError({ message: error.message });
            }
        },
    }),
});

